export default __webpack_public_path__ + "static/media/pink-plus-dark.78426b71.svg";